var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"cicle",style:(index == _vm.active
          ? 'background-color: #321fdb'
          : 'background-color: #89ABE6;')})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }